namespace TabAurous {

    @Serenity.Decorators.registerEditor()
    export class CommonDepartmentLookup extends
        Serenity.LookupEditorBase<Serenity.LookupEditorOptions, OMS.DepartmentMasterRow> {
        /*
         1.For FG and Both
         2.For WIP and Both
         */
        public DepartmentTypeId: number;

        constructor(container: JQuery, opt: Serenity.LookupEditorOptions) {
            super(container, opt);
        }

        protected getLookupKey() {
            return OMS.DepartmentMasterRow.lookupKey;
        }

        protected getItems(lookup: Q.Lookup<any>) {
            var results = Q.getLookup(OMS.DepartmentMasterRow.lookupKey);
            
            let items = super.getItems(results);
            if (this.DepartmentTypeId==1) {

                let filters = {
                    DepartmentTypeId:[141,143]
                };
                
                items = q.Filter(items, filters)
            } else if (this.DepartmentTypeId == 2) {
                let filters = {
                    DepartmentTypeId: [142, 143]
                };

                items = q.Filter(items, filters)
            }
            return items;
        }

    }

}
